<template>
  <Transition name="fade">
    <div v-if="show" class="modal-wrapper" @click.self.stop>
      <div class="continue-modal">
        <div class="continue-modal__close" @click="clickHandler(true, $event)">
          <Icons variant="close" />
        </div>
        <div class="continue-modal-body">
          <div class="continue-modal-body__title">{{ $t('authQuestion.doContinue') }}</div>
        </div>
        <div class="continue-modal-buttons">
          <div class="btn btn_outlined" @click="clickHandler(false, $event)">{{ $t('global.no') }}</div>
          <div class="btn" @click="clickHandler(true, $event)">{{ $t('global.yes') }}</div>
        </div>
      </div>
    </div>
  </Transition>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue';
import { useTerminalStore, usePaymentStore } from '@/stores';
import Icons from '@/components/UI/Icons/';
import { rebootToIdle } from '@/utils/metrikaSession';

const props = withDefaults(defineProps<{
    show?: boolean
}>(), {
    show: false
});

const emit = defineEmits<{
    (e: 'resetTimer'): void
    (e: 'close'): void
}>();

const paymentStore = usePaymentStore();
const terminalStore = useTerminalStore();

const inactivityTimer = ref<number | null>(null);

function resetState() {
    terminalStore.resetState();
}

function clickHandler(shouldContinue: boolean, event?: Event) {
    if (event) {
        event.stopPropagation();
        event.preventDefault();
    }

    // Сообщи родителю, что нужно закрыть модалку
    emit('close');

    if (shouldContinue) {
        emit('resetTimer');
        clearTimeout(inactivityTimer.value ?? undefined);
    } else {
        paymentStore.setOrder(null);
        resetState();
        rebootToIdle();
        clearTimeout(inactivityTimer.value ?? undefined);
    }
}

function resetInactivityTimer() {
    clearTimeout(inactivityTimer.value ?? undefined);
    inactivityTimer.value = window.setTimeout(() => {
        clickHandler(false);
    }, 20000);
}

watch(() => props.show, (newValue) => {
    if (newValue) {
        resetInactivityTimer();
    } else {
        clearTimeout(inactivityTimer.value ?? undefined);
    }
});
</script>
<style scoped lang="scss">
.continue-modal {
    position: relative;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 70dvw;
    height: 500px;
    background: var(--color-white);
    border-radius: 30px;
    [data-product="kiosk"] & {
        width: 560px;
        height: 272px;
    }

    &__close {
        position: absolute;
        top: 32px;
        right: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 48px;
        color: var(--color-red);
        border: 2px solid var(--color-red);
        box-shadow: 1px 1px 6px 0 #002D1D0D;
        border-radius: 50%;
    }

    &-body {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        font-size: 36px;
        font-weight: 700;
    }

    &-buttons {
        display: flex;
        align-items: center;
        gap: 36px;
        width: 100%;

        & .btn {
            width: 100%;
        }
    }
}
</style>